import React from "react";
import { Link } from "react-router-dom";
import IconArrowLeft from "../../../src/component/SvgIcons/IconArrowLeft";
import IconArrowRight from "../../../src/component/SvgIcons/IconArrowRight";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null; // Hide if there is only one or no page

  return (
    <ul className="pagination d-flex align-items-center justify-content-end">
      {/* Previous Button */}
      <li>
        <Link
          to="#"
          onClick={() => onPageChange(currentPage - 1)}
          className={`pagination-link ${currentPage === 1 ? "disabled" : ""}`}
        >
          <IconArrowLeft />
        </Link>
      </li>

      {Array.from({ length: totalPages }, (_, index) => index + 1)
        .filter((page) => {
          return (
            page === 1 || // Always show first page
            page === totalPages || // Always show last page
            (page >= currentPage - 1 && page <= currentPage + 1) // Show previous, current, and next pages
          );
        })
        .map((page, index, filteredPages) => (
          <React.Fragment key={page}>
            {index > 0 && page !== filteredPages[index - 1] + 1 && (
              <li className="pagination-dots">...</li> // Show dots for gaps
            )}
            <li>
              <Link
                to="#"
                onClick={() => onPageChange(page)}
                className={`pagination-link ${
                  currentPage === page ? "active" : ""
                }`}
              >
                {page}
              </Link>
            </li>
          </React.Fragment>
        ))}

      {/* Next Button */}
      <li>
        <Link
          to="#"
          onClick={() => onPageChange(currentPage + 1)}
          className={`pagination-link ${
            currentPage === totalPages ? "disabled" : ""
          }`}
        >
          <IconArrowRight />
        </Link>
      </li>
    </ul>
  );
};

export default Pagination;
